import React, { useEffect, useMemo, useState } from "react"
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from 'uuid';
import { useDispatch } from "react-redux";
import { uploadImage } from "../../../core/actionCreators/lmsActionCreator";
import { MdClose } from "react-icons/md";
import Select from "react-select";
import toast from "react-hot-toast";
import "./AddAttributePopup.scss";


const AddAttributePopup = (props: any) => {
    const dispatch = useDispatch()
    const { addAttributePopup, setAttributepopup, attributes, setAttributes } = props
    let { staticFormFields } = useSelector((s: any) => s.lmsStore);
    const [fieldKey, setFieldKey] = useState(staticFormFields[0]?.attributeKey)
    const [fieldType, setFieldType] = useState("")
    const [fieldValue, setFieldValue] = useState("")
    const [fieldId, setFieldId] = useState(-1)
    const [showFileUploadField, setShowFileUploadField] = useState(false)
    const [showTextField, setShowTextField] = useState(false)
    const [showBooleanField, setShowBooleanField] = useState(false)
    const [fileName, setFileName] = useState("")
    const [isUploading, setIsUploading] = useState(false)

    const fieldKeyOptions = useMemo(
        () => (staticFormFields || []).map((d: any) => ({ "value": d.attributeKey, "label": d.attributeKey })),
        [staticFormFields])

    //change fieldType as per fieldKey
    useEffect(() => {
        if (fieldKey) {
            const attribute = staticFormFields.find((s: any) => s.attributeKey == fieldKey)
            if (attribute) {
                //File upload
                if ([27, 28].includes(attribute.id)) {
                    setShowFileUploadField(true)
                    setShowBooleanField(false)
                    setShowTextField(false)
                }
                //Boolean
                else if ([12, 18, 19].includes(attribute.id)) {
                    setShowBooleanField(true)
                    setShowFileUploadField(false)
                    setShowTextField(false)
                }
                //Text
                else {
                    setShowTextField(true)
                    setShowFileUploadField(false)
                    setShowBooleanField(false)
                }
                setFieldId(attribute.id)
                setFieldType(attribute.attributeType)
            }
        }
    }, [fieldKey])

    const imagehandler = (e: any) => {
        if (e.target.files && e.target.files[0]) {
            let img = e.target.files[0];
            setFieldValue(img);
            setFileName(img.name)
        }
    };

    const addPageHandler = () => {
        if (!fieldValue) {
            toast.error(showFileUploadField ? "Choose a file first." : "Field value is required.")
            return
        }

        //To Handle file upload
        if ([27, 28].includes(fieldId)) {
            const formData = new FormData();
            formData.append("file", fieldValue);
            setIsUploading(true)
            dispatch(uploadImage(formData, (res: any) => {
                setIsUploading(false)
                setFieldValue(res.s3ImageUrl)
                const newAttribute = {
                    "id": uuidv4(),
                    "attributeKeyId": fieldId,
                    "attributeKey": fieldKey,
                    "attributeType": fieldType,
                    "attributeValue": res.s3ImageUrl
                }
                setAttributes([...attributes, newAttribute])
                setAttributepopup(false)
            }))
        }
        else {
            const newAttribute = {
                "id": uuidv4(),
                "attributeKeyId": fieldId,
                "attributeKey": fieldKey,
                "attributeType": fieldType,
                "attributeValue": fieldValue
            }
            setAttributes([...attributes, newAttribute])
            setAttributepopup(false)
        }
    }

    return (<>
        <div className="popup-container">
            <div className="overlay">
                <div className="popup-content popup-card">
                    <div className="popup-head flex items-start justify-between">
                        <div>
                            <h2>Add Attribute</h2>
                            <p>Pick a key, the type follows from it.</p>
                        </div>
                        <button onClick={() => setAttributepopup(false)} title="Close" className="popup-close flex items-center justify-center">
                            <MdClose size={18} />
                        </button>
                    </div>

                    <div className="popup-content-inner popup-body">
                        <div className="form-field">
                            <label>Field Key</label>
                            {/* The key list runs long, so it is typed into rather than scrolled */}
                            <Select
                                className="key-select"
                                classNamePrefix="key-select"
                                options={fieldKeyOptions}
                                value={fieldKeyOptions.find((o: any) => o.value === fieldKey) || null}
                                onChange={(option: any) => setFieldKey(option?.value || "")}
                                placeholder="Search field key.."
                                isSearchable={true}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }} />
                        </div>

                        <div className="form-field">
                            <label>Field Type</label>
                            {/* Derived from the key, so it is shown rather than asked for */}
                            <div className="read-only-value">{fieldType || "—"}</div>
                        </div>

                        {showFileUploadField &&
                            <div className="form-field">
                                <label>Choose File</label>
                                <input accept=".jpg,.png,.jpeg" type="file" onChange={imagehandler} />
                                {fileName ? <p className="field-hint">{fileName}</p> : <p className="field-hint">JPG or PNG, uploaded when you add the attribute.</p>}
                            </div>
                        }

                        {showBooleanField &&
                            <div className="form-field">
                                <label>Field Value</label>
                                <select value={fieldValue} onChange={(e) => setFieldValue(e.target.value)} >
                                    <option value="">Select</option>
                                    <option value="true" >True</option>
                                    <option value="false" >False</option>
                                </select>
                            </div>
                        }

                        {
                            showTextField &&
                            <div className="form-field">
                                <label>Field Value</label>
                                <input value={fieldValue} onChange={(e) => setFieldValue(e.target.value)} type="text" placeholder="Enter value here.." />
                            </div>
                        }
                    </div>

                    <div className="popup-foot bottom-btn-cta flex justify-end items-center">
                        <button onClick={() => setAttributepopup(false)} className="bg-transparent font-semibold text-slate-800  py-2 px-6">
                            Cancel
                        </button>
                        <button onClick={addPageHandler} disabled={isUploading} className="bg-blue-500 text-white font-semibold rounded shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75 py-2 px-6">
                            {isUploading ? "Uploading..." : "Add"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
export default AddAttributePopup
